import main from './modules/main.vue'
export default main